import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './SubmitFinePrint.module.css';

/**
 * A component that displays the fine print for the submit button.
 * Note: this is not in use for ProductOrderForm.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.payoutDetailsWarning] - The payout details warning
 * @param {boolean} [props.isOwnListing] - Whether the listing is owned by the current user
 */
const SubmitFinePrint = ({
  payoutDetailsWarning,
  isOwnListing,
  omitYouWontBeChargedMessage = false,
}) => {
  const content = payoutDetailsWarning ? (
    payoutDetailsWarning
  ) : isOwnListing ? (
    <FormattedMessage id="OrderPanel.ownListingNotice" />
  ) : !omitYouWontBeChargedMessage ? (
    <FormattedMessage id="OrderPanel.youWontBeChargedInfo" />
  ) : null;

  // Nothing to say, nothing to render. The <p> used to be emitted regardless, and `.finePrint`
  // composes marketplaceTinyFontStyles — so on every soft-booking listing an empty paragraph put
  // roughly 20px of blank space between the submit button and the hint that replaced its text.
  if (!content) {
    return null;
  }

  return <p className={css.finePrint}>{content}</p>;
};

export default SubmitFinePrint;
